var exports = {
  "kL": "InboxPopout.module__container___TnVwY3",
  "rf": "InboxPopout.module__body___TnVwY3",
  "pz": "InboxPopout.module__sidebar___TnVwY3",
  "G9": "InboxPopout.module__sidebarTabList___TnVwY3",
  "NP": "InboxPopout.module__sidebarFooterActions___TnVwY3",
  "jR": "InboxPopout.module__sidebarActionButton___TnVwY3",
  "M6": "InboxPopout.module__mainPanel___TnVwY3",
  "yt": "InboxPopout.module__sidebarTab___TnVwY3",
  "yR": "InboxPopout.module__tabActive___TnVwY3",
  "DF": "InboxPopout.module__tabInactive___TnVwY3",
  "Qs": "InboxPopout.module__content___TnVwY3",
  "Lj": "InboxPopout.module__tabContent___TnVwY3",
  "Bx": "InboxPopout.module__iconSmall___TnVwY3",
};

module.exports = exports;
